// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../isFirstDayOfMonth/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var isFirstDayOfMonth = convertToFP(fn, 1);
export default isFirstDayOfMonth;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/isFirstDayOfMonth/index.js
// module id = 924
// module chunks = 0